// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__mjoj7","section":"styles_section__5sVmo","nav":"styles_nav__OYEnl","selected":"styles_selected__qVjT2"};